import { GETTERS } from "./names";
import { State } from "./types";

export default {
    [GETTERS.ID]: (_state: State, _getters, _rootState, rootGetters) => rootGetters['map/mapModule/metaverseId'],
}